import React from 'react';
import { CheckoutButton } from '../CheckoutButton';
const tools = [{
  emoji: '🧭',
  title: 'Prostho Master Map',
  text: 'A visual overview of Prosthodontics you can scan in seconds.'
}, {
  emoji: '📋',
  title: 'Rapid Review Checklists',
  text: 'Quick checklists to identify what you know and what still needs review.'
}, {
  emoji: '🔀',
  title: 'Clinical Decision Maps™',
  text: 'Visual pathways that help you connect concepts instead of memorizing isolated facts.'
}, {
  emoji: '⚠️',
  title: 'Error Control™',
  text: 'A library of commonly confused concepts so you can spot your weak areas faster.'
}, {
  emoji: '⏱️',
  title: 'The 15-Minute Review System',
  text: 'A practical framework for making short study sessions count.'
}, {
  emoji: '🧠',
  title: 'Active Recall Bank',
  text: 'Quick questions designed to help you test whether you actually remember what you studied.'
}];
export function ToolsSection() {
  return <section className="bg-white px-4 py-14 sm:py-20" data-id="element-321" data-mp="1rrqbpk97mjfs">
      <div className="mx-auto w-full max-w-5xl" data-id="element-322" data-mp="1ruktf40u9q5i">
        <div className="text-center" data-id="element-323" data-mp="1msn906gpcpaz">
          <p className="text-[11px] font-extrabold uppercase tracking-[0.18em] text-aqua-500" data-id="element-324" data-mp="1mvrkzq0espc7">
            📲 Plus, immediate access to
          </p>
          <h2 className="mt-3 font-display text-[26px] font-bold leading-[1.14] tracking-tight text-navy-900 sm:text-4xl" data-id="element-325" data-mp="1wsw6dnmfkgry">
            6 study tools you'll actually use before every exam
          </h2>
        </div>

        <div className="mt-9 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-326" data-mp="144i4gws810b4">
          {tools.map(tool => <article key={tool.title} className="flex h-full flex-col rounded-2xl bg-sand-50 p-5 ring-1 ring-navy-800/8" data-id="element-327" data-mp="1itmpelqehimx">
              <span className="text-3xl leading-none" aria-hidden="true" data-id="element-328" data-mp="qaza5my34xtr">
                {tool.emoji}
              </span>
              <h3 className="mt-3 text-[15.5px] font-extrabold uppercase tracking-wide text-navy-900" data-id="element-329" data-mp="lbwgeynk2e13">
                {tool.title}
              </h3>
              <p className="mt-2 text-[14px] leading-relaxed text-navy-800/70" data-id="element-330" data-mp="1f2ex079hx45b">{tool.text}</p>
            </article>)}
        </div>

        <p className="mx-auto mt-8 max-w-2xl text-center text-[15.5px] leading-relaxed text-navy-800/75 sm:text-lg" data-id="element-331" data-mp="1jug83puxgotr">
          Whatever Prosthodontics topic you need to review, you'll have{' '}
          <strong className="font-bold text-navy-900" data-id="element-332" data-mp="s30ng1cxlc66">
            a clear path for where to start, what to compare, and what to review next.
          </strong>
        </p>

        <div className="mt-8" data-id="element-333" data-mp="1124839rqxzms">
          <CheckoutButton label="I want full access to Prostho 360™" sub="$27 · Instant digital access" data-id="element-334" data-mp="111vutgrposb2" />
        </div>
      </div>
    </section>;
}